import type { FaireProductEntity } from "../../entity_types/product";

export const p_dm7ejpzu8e: FaireProductEntity = {
  token: "p_dm7ejpzu8e",
  type: "product",
  name: "Coast of Maine \u2013 Driftwood & Sea Salt 5oz Wood Wick Scented Candle for a Coastal Home.",
  brandName: "ShoreItUp",
  imageUrl:
    "https://cdn.faire.com/fastly/8e5f7a6a03f41f3bcca38d7234a6e72dad43b84dc251dd7fa379a2582b889180.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f2e3aea99aa695d4a439a1b39a16bbfcc07111d4a3ec0ec116f1a482e211fae5.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
